import loadable from '@loadable/component';

export const LazyCurationsIndex = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/curationsindex" */
      '.'
    ),
);
